import allFeaturesOnApp from "../../assets/images/allFeaturesOnApp.webp";
import AppleStoreDownload from "../../assets/images/appleStoreDownload.png";
import GooglePlayDownload from "../../assets/images/googlePlayDownload.png";
import { LINKS } from "../../constants/links";

export function AppDownloadCTACard() {
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  const isAndroid = /Android/.test(navigator.userAgent);
  const isMobile = isIOS || isAndroid;

  return (
    <div className="w-full h-[300px] bg-black rounded-2xl flex flex-col  justify-between relative overflow-hidden">
      <img
        src={allFeaturesOnApp}
        alt="All features on the app"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="relative z-10 h-full flex flex-col justify-between">
        <div className="max-w-[400px] px-4 py-4 text-2xl text-white ">
          Access all membership features on the app
        </div>
        <div className="flex flex-row items-center justify-center gap-4 mb-4 w-full px-4">
          {isIOS && (
            <a
              href={LINKS.IOS_APP_STORE}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={AppleStoreDownload} alt="Apple Store Download" />
            </a>
          )}
          {isAndroid && (
            <a
              href={LINKS.ANDROID_PLAY_STORE}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={GooglePlayDownload} alt="Google Play Download" />
            </a>
          )}
          {!isMobile && (
            <>
              <a
                href={LINKS.IOS_APP_STORE}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={AppleStoreDownload} alt="Apple Store Download" />
              </a>
              <a
                href={LINKS.ANDROID_PLAY_STORE}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={GooglePlayDownload} alt="Google Play Download" />
              </a>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
